
export default {
  add: ['ctrl', '+'],
  delete: ['ctrl', '-'],
  save: ['ctrl', 's'],
}
